export const IndicatorMenu = {
  routes: [
    {
      name: 'works',
      displayName: 'menu.works',
      subject_class: 'Works'
    },
    {
      name: 'ranking',
      displayName: 'menu.ranking',
      subject_class: 'Ranking'
    },
    {
      name: 'mounting_time',
      displayName: 'menu.mounting_time',
      subject_class: 'MountingTime'
    },
    {
      name: 'free_time',
      displayName: 'menu.free_time',
      subject_class: 'FreeTime'
    },
    {
      name: 'products_by_boxes',
      displayName: 'menu.products_by_boxes',
      subject_class: 'Ranking'
    },
    {
      name: 'products_by_pallets',
      displayName: 'menu.products_by_pallets',
      subject_class: 'Ranking'
    },
  ]
}

